import { noop } from "@/helpers/functions/FunctionHelpers";

export function createDeferred() {
  let _resolve = noop;
  const promise = new Promise((resolve) => (_resolve = resolve));

  return {
    resolve: _resolve,
    promise,
  };
}
